import * as React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Tooltip, useMediaQuery } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axios from 'axios';
import { USER_REFFERAL } from '../../api/vsc';
import { useParams } from 'react-router-dom';

export default function RefferalTable({ externalUser }) {
  const params = useParams();
  const [user, setUser] = React.useState({});
  const isMobile = useMediaQuery('(max-width: 600px)');

  React.useEffect(() => {
    // If the parent provided the user data, use it. Otherwise, fetch it.
    if (externalUser && Object.keys(externalUser).length > 0) {
      setUser(externalUser);
    } else if (params.id) {
      axios
        .get(USER_REFFERAL + params.id)
        .then((response) => {
          setUser(response.data.data);
        })
        .catch((err) => console.error("Table Fetch Error:", err));
    }
  }, [externalUser, params.id]);

  return (
    <TableContainer 
      component={Paper} 
      sx={{ 
        borderRadius: '16px', 
        border: '1px solid #f0f0f0', 
        boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
        overflow: 'hidden' 
      }}
    >
      <Table sx={{ minWidth: 100 }} aria-label="referral table">
        <TableHead sx={{ background: '#6a58c6' }}>
          <TableRow>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Invited Friends</TableCell>
            {!isMobile && <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Email</TableCell>}
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Referral Bonus</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {user.referredEmails && user.referredEmails.length > 0 ? (
            user.referredEmails.map((referred, index) => (
              <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
                  {referred.name || "Anonymous"}
                </TableCell>
                {!isMobile && <TableCell>{referred.email}</TableCell>}
                <TableCell align="left">
                  <Tooltip title={referred.paid ? "Bonus unlocked!" : "You receive a referral amount once the referee purchases a program without refund"}>
                    <Chip
                      sx={{ 
                        fontWeight: 'bold', 
                        backgroundColor: referred.paid ? '#e8f5e9' : '#f5f5f5',
                        color: referred.paid ? '#2e7d32' : '#757575'
                      }}
                      label={`₹100`}
                      icon={
                        referred.paid ? 
                        <CheckCircleIcon style={{ color: '#2e7d32', fontSize: '18px' }} /> : 
                        <LockIcon style={{ color: '#757575', fontSize: '18px' }} />
                      }
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} align="center" sx={{ py: 3, color: '#999' }}>
                No referrals yet. Start sharing your link to earn rewards!
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}